.output-documents-panel {
  .folder-description {
    margin: 0 0 20px 0;
  }

  td {
    padding: 10px 2px 10px 0;
    line-height: 1.3rem;
    vertical-align: top;
  }

  .btn-link {
    line-height: 1.3rem;
    display: block;
    cursor: pointer;
  }

  .icon {
    padding-right: 4px;
  }

  .file-size {
    white-space: nowrap;
  }
}
